import { ComplaintColumn } from "./complaintColumn"
import {
  ComplaintDistinctValues,
  IComplaintColumn,
} from "./complaintColumn.types"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { GetComplaintColumnValuesQuery } from "@/api/hasura/generated/graphql"

export type ComplaintColumnRaw = GetComplaintColumnValuesQuery

const getDistinctValues = (
  data: ComplaintColumnRaw,
): ComplaintDistinctValues => {
  const result: ComplaintDistinctValues = {}

  const rows = data.complaint
  if (!rows?.length) return result

  rows.forEach((row) => {
    Object.entries(row).forEach(([column, value]) => {
      if (value) {
        if (!result[column]) {
          result[column] = {}
        }
        result[column][value] = value
      }
    })
  })

  return result
}

export const ComplaintColumnParser: IParser<
  IComplaintColumn,
  ComplaintColumnRaw
> = {
  toDomain: (data): IComplaintColumn => {
    try {
      const parsedData = getDistinctValues(data)

      return new ComplaintColumn({
        channel: parsedData.channel,
        type: parsedData.type,
        team: parsedData.team,
        agentName: parsedData.agent_name,
        status: parsedData.status,
        subStatus: parsedData.sub_status,
        category1: parsedData.category1,
        category2: parsedData.category2,
        category3: parsedData.category3,
        ofgemCategory: parsedData.ofgem_mapped_complaint_category,
        internalCategory: parsedData.internal_complaint_category,
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
